export enum PaymentRailType {
  COP = 'COP',
  PIX = 'PIX',
  SPEI = 'SPEI',
  CVU = 'CVU',
  ACH = 'ACH',
  RTP = 'RTP',
  Wire = 'WIRE',
  Polygon = 'POLYGON',
  LocalExchange = 'LOCAL_EXCHANGE',
  TRON = 'TRON',
  Ethereum = 'ETH',
  Swift = 'SWIFT',
  SEPA = 'SEPA',
  Cnaps = 'CNAPS',
  Chats = 'CHATS',
  CalizaWallet = 'CALIZA_WALLET',
  RevenueEarnings = 'REVENUE_EARNINGS',

  // Thunes local corridors — mirror caliza-core-api PR #3411 PaymentRailType enum.
  // Backend reuses ACH for BOB; the rails below are the new ones.
  FasterPayments = 'FASTER_PAYMENTS', // GBP / United Kingdom
  IMPS = 'IMPS', // INR / India
  INSTAPAY = 'INSTAPAY', // PHP / Philippines
  RTC = 'RTC', // ZAR / South Africa
  PromptPay = 'PROMPTPAY', // THB / Thailand
  BiFast = 'BI_FAST', // IDR / Indonesia bank transfer
  GHIPSS = 'GHIPSS', // GHS / Ghana
  Pesalink = 'PESALINK', // KES / Kenya bank transfer
  Fast = 'FAST', // TRY / Turkey
  EFT = 'EFT', // CAD / Canada
  TEF = 'TEF', // CLP / Chile
  NIP = 'NIP', // NGN / Nigeria
  CCE = 'CCE', // PEN / Peru
  IPP = 'IPP', // AED / UAE
  MobileWallet = 'MOBILE_WALLET', // IDR + KES mobile money
  Local = 'LOCAL', // generic Thunes fallback (mirrored for parity)

  unset = '',
}

// TODO: move to a separate file
export enum CurrencyCodeType {
  USDC = 'USDC',
  USDT = 'USDT',
  MXNB = 'MXNB',
  BRL1 = 'BRL1',

  USD = 'USD',
  BRL = 'BRL',
  MXN = 'MXN',
  COP = 'COP',

  ARS = 'ARS',
  CNY = 'CNY',
  HKD = 'HKD',
  SGD = 'SGD',
  EUR = 'EUR',

  // Thunes local corridors (caliza-core-api PR #3411). Only currencies with a
  // configured corridor are added here — the 12 backend currencies without one
  // (BDT, PKR, VND, MYR, EGP, JPY, KRW, TWD, ETB, TZS, UGX, ZMW) are intentionally
  // left out and will be added when their corridors land.
  GBP = 'GBP',
  INR = 'INR',
  PHP = 'PHP',
  ZAR = 'ZAR',
  THB = 'THB',
  IDR = 'IDR',
  GHS = 'GHS',
  KES = 'KES',
  TRY = 'TRY',
  CAD = 'CAD',
  CLP = 'CLP',
  NGN = 'NGN',
  BOB = 'BOB',
  PEN = 'PEN',
  AED = 'AED',

  ANY = 'ANY',
  UNSET = '',
}

export interface CurrencyWithSwiftFlag {
  readonly currency: CurrencyCodeType;
  readonly swift: boolean;
}

export interface FundingMethodItem {
  readonly id: string;
  readonly method: PaymentRailType;
  readonly currency: CurrencyCodeType;
  readonly fundingSource?: 'customer' | 'integrator';
}

export interface DashboardOperationDestination {
  readonly currency: CurrencyCodeType;
  readonly rail: PaymentRailType;
  readonly fundingMethods: readonly PaymentRailType[];
}

export interface DashboardOperation {
  readonly currency: CurrencyCodeType;
  readonly destinations: readonly DashboardOperationDestination[];
}
